<template>
  <div class="DaiJia ">
    <div class="content">
      <div class="banner" v-if="daijiaBanner && daijiaBanner.length>0">
        <xk-roll-banner :data="daijiaBanner"></xk-roll-banner>
      </div>
      <div class="setSite">
        <div class="typeNav">
          <xk-type-tabs v-if="typeAll.data.length>0" :cardata="typeAll" @click="typeTabFn"
                        :defaultmum="0"></xk-type-tabs>
        </div>
        <div class="title">
          “附近有 <span style="color: #f06553">{{ getNearDrivers.length || 0 }}</span> 位司机候驾”
        </div>
        <div class="row row1 clear">
          <i class="iconfont icon-yuan"></i>
          <div class="val">
            <xk-site-input placeholder="请输入起点位置" @onClick="startCityFn"
                           :name="positioning?positioning.name:''" :state="true"
            ></xk-site-input>
          </div>
        </div>
        <div class="row row2 clear">
          <i class="iconfont icon-yuan"></i>
          <div class="val">
            <xk-site-input placeholder="请输入终点位置" @onClick="endCityFn"
                           checkedlogin :name="adds.endAdd.endAddress" :addressrecord="addressRecordFn"
                           :state="true"></xk-site-input>
          </div>
        </div>
        <div class="row row3 clear">
          <div class="top">
            <span class="list" :class="others.othersPhone!==''?'listAc':''"
                  style="display: inline-flex;vertical-align: top;justify-content: center;">
              <i class="iconfont icon-mine"></i>
              <div class="listVal" @click="othersPhoneFn('show')">
                <p v-if="others.state">为别人叫</p><p v-else>{{ others.recordPhone }}</p>
              </div>
            </span>
            <span class="list listAc" @click="selectTimeFn"
                  style="display: inline-flex;vertical-align: top;justify-content: center;">
              <i class="iconfont icon-shijian1"></i><p>{{ startTime.name }}</p>
            </span>
          </div>
        </div>
        <div class="totalNum clear">
          <div class="row" @click="chooseDriverFn">
            <div style="width: 100%"><span>选择</span><span class="red">{{ driverNumber }}</span><span>位司机</span>
            </div>
          </div>
          <div class="line"></div>
          <div class="row">
            <xk-coupon-select @click="couponSlelectFn" :type="'daijia'" :data="djCoupnsGetter"></xk-coupon-select>
          </div>
        </div>
        <div class="totalNum">
          <div class="row" @click="detailsBoxFn" style="width: 100%;line-height: 4.5rem;">
            <div style="width: 100%">
              <span v-if="budgetFee">{{ loginData && loginData.passenger ? '约' : '起步价' }}</span>
              <span class="red">{{ budgetFee }}</span>
              <span v-if="budgetFee">元</span>
              <i class="iconfont icon-iconfontyiwen" v-if="budgetFee"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="callOutBut">
        <button @click="callCarFn('private')" :disabled="loadState" :class="{disable: loadState}" v-if="!enterprise_id">
          一键下单
        </button>
        <button @click="callCarFn('private')" :disabled="loadState" :class="{disable: loadState}" v-if="enterprise_id">
          个人出行
        </button>
        <button @click="callCarFn('official')" :disabled="loadState || enterpriseDisabled"
                :class="{disable: loadState || enterpriseDisabled}"
                v-if="!adds.endAdd.endLat && enterprise_id && ygcx && (is_fixed_price == 1)">因公出行(一口价0元)
        </button>
        <button @click="callCarFn('official')" :disabled="loadState || enterpriseDisabled"
                :class="{disable: loadState || enterpriseDisabled}"
                v-if="adds.endAdd.endLat && enterprise_id && ygcx && (is_fixed_price==1)">因公出行(一口价{{ money }}元)
        </button>
        <button @click="callCarFn('official')" :disabled="loadState || enterpriseDisabled"
                :class="{disable: loadState || enterpriseDisabled}"
                v-if="adds.endAdd.endLat && enterprise_id && ygcx && (is_fixed_price !==1)">因公出行(可抵扣)
        </button>
        <button @click="callCarFn('official')" :disabled="loadState || enterpriseDisabled"
                :class="{disable: loadState || enterpriseDisabled}"
                v-if="!adds.endAdd.endLat && enterprise_id && ygcx && (is_fixed_price !==1)">因公出行(可抵扣)
        </button>
        <p v-if="is_deduction === 2" style="text-align: center;color: #999;font-size: 12px;">
          您尚未开启企业优惠抵扣权限，请联系管理员</p>
      </div>
      <xk-input-box ref="othersPhone" title="乘车人电话" v-if="others.showState" @click="othersPhoneFn">
        <div slot="content">
          <input class="othersPhoneInput" placeholder="输入乘车人电话" v-model="others.othersPhone"
                 @input="othersPhoneCheck"/>
        </div>
      </xk-input-box>
      <xk-date-picker-mod @click="DatePickerFn" ref="DatePicker" v-if="datePickerState"></xk-date-picker-mod>
    </div>
    <xk-unfilled-order-mod
      v-if="unfilledOrderState && unfilledOrderState.daijia && unfilledOrderFn.length>0"
      :data="unfilledOrderFn?unfilledOrderFn:null" :title="'代驾'"
      @close="unfilledOrdercCloseFn"></xk-unfilled-order-mod>
    <!--<xk-upload-mod :state="loadState"></xk-upload-mod>-->
    <xk-hint-box v-if="hintBox.stateShow" :state="hintBox.state" :content="hintBox.content"></xk-hint-box>
    <Xk-detailsBox v-if="feeObj" :title="'费用详情'" class="costBox" ref="detailsBox">
      <div slot="content">
        <div class="List">
          <ul>
            <li class="clear">
              <span class="name">总价</span>
              <span class="val"><span class="sum">{{ feeObj.total_fee / 100 }}</span><span class="unit">元</span></span>
            </li>
            <li class="clear" v-if="feeObj.distance_fee">
              <span class="name">里程费</span>
              <span class="val"><span class="sum">{{ feeObj.distance_fee / 100 }}</span><span
                class="unit">元</span></span>
            </li>
            <li class="clear" v-if="feeObj.time_fee">
              <span class="name">时间费</span>
              <span class="val"><span class="sum">{{ feeObj.time_fee / 100 }}</span><span class="unit">元</span></span>
            </li>
            <li class="clear">
              <span class="name">起步价</span>
              <span class="val"><span class="sum">{{ feeObj.start_price / 100 }}</span><span
                class="unit">元</span></span>
            </li>
          </ul>
        </div>
        <div class="introduce" style="max-height: 40vh;overflow-y: auto" v-html="budgetFeeRemark"></div>
      </div>
    </Xk-detailsBox>
    <!--选择司机-->
    <xk-my-picker
      :showMyPicker="visible"
      :pickItem="slots"
      title="选择司机人数"
      @sureAction="sureSelectCar"
      @cancelAction="cancleSelectCar">
    </xk-my-picker>
  </div>
</template>

<script>
import Toucth from '../../../assets/js/method'
import {mapGetters} from 'vuex'
import XkRollBanner from '../../module/rollBanner/src/rollBanner'
import XkSiteInput from '../../module/siteInput/src/siteInput'
import XkInput from '../../module/input/src/input'
import XkDetailsBox from '../../module/detailsBox/src/detailsBox'
import XkInputBox from '../../module/inputBox/src/inputBox'
import XkDatePickerMod from '../../module/datePickerMod/src/datePickerMod'
import XkCouponSelect from '../../module/couponSelect/src/couponSelect'
import XkUploadMod from '../../module/uploadMod/src/uploadMod'
import XkUnfilledOrderMod from '../../module/unfilledOrderMod/src/unfilledOrderMod'
import XkHintBox from '../../module/hintBox/src/hintBox'
import xkMyPicker from '../../module/myPicker/myPicker'
import {Picker} from 'mint-ui'
import Cookie from 'js-cookie'
import JSONBig from 'json-bigint-xk'

export default {
  components: {
    XkHintBox,
    XkUnfilledOrderMod,
    XkUploadMod,
    XkCouponSelect,
    XkDatePickerMod,
    XkInputBox,
    XkDetailsBox,
    XkInput,
    XkSiteInput,
    XkRollBanner,
    xkMyPicker,
    Picker
  },
  name: 'DaiJia',
  computed: {
    ...mapGetters({
      daijiaBanner: 'daijiaBanner',
      DjBudgetCost: 'DjBudgetCost',
      DJBusiness: 'DJBusiness',
      addressRecord: 'addressRecord',
      loginData: 'loginData',
      positioning: 'positioning',
      companyInfo: 'companyInfo',
      getNearDrivers: 'getNearDrivers',
      unfilledOrderState: 'unfilledOrderState',
      unfilledOrder: 'unfilledOrder',
      djCoupnsGetter: 'djCoupnsGetter',
      login: 'login'
    }),
    unfilledOrderFn: function () { // 准备未完成订单数据
      let unfilledOrder = []
      let daijiaData = []
      if (this.unfilledOrder && this.unfilledOrder.length > 0) {
        this.unfilledOrder.forEach((row) => {
          if (row.business === 'daijia') {
            daijiaData.push(row)
          }
        })
        if (daijiaData && daijiaData.length > 0) {
          let obj = {}
          for (let i = 0; i < daijiaData.length; i++) {
            obj = {
              startAddress: daijiaData[i].book_address,
              endAddress: daijiaData[i].destination,
              serverTime: Toucth.TimestampDate(daijiaData[i].book_time),
              orderId: daijiaData[i].id,
              status: ''
            }
            switch (daijiaData[i].status) {
              case 1:
                obj.status = {
                  name: '新单',
                  router: {path: '/daijia/await', query: {order_id: daijiaData[i].id}}
                }
                break
              case 5:
                obj.status = {
                  name: '等待中',
                  router: {path: '/daijia/await', query: {order_id: daijiaData[i].id}}
                }
                break
              case 10:
                obj.status = {
                  name: '已接单',
                  router: {path: '/daijia/service', query: {order_id: daijiaData[i].id}}
                }
                break
              case 15:
                obj.status = {
                  name: '前往达预约地',
                  router: {path: '/daijia/service', query: {order_id: daijiaData[i].id}}
                }
                break
              case 20:
                obj.status = {
                  name: '到达预约地',
                  router: {path: '/daijia/service', query: {order_id: daijiaData[i].id}}
                }
                break
              case 25:
                obj.status = {
                  name: '前往目的地',
                  router: {path: '/daijia/service', query: {order_id: daijiaData[i].id}}
                }
                break
              case 28:
                obj.status = {
                  name: '等待',
                  router: {path: '/daijia/service', query: {order_id: daijiaData[i].id}}
                }
                break
              case 30:
                obj.status = {
                  name: '待结算',
                  router: {path: '/daijia/settlement', query: {order_id: daijiaData[i].id, app_key: this.app_key}}
                }
                this.$router.push({
                  path: '/daijia/settlement',
                  query: {order_id: daijiaData[i].id, app_key: this.app_key}
                })
                break
              case 35:
                obj.status = {
                  name: '待评价',
                  router: {path: '/daijia/affirm', query: {order_id: daijiaData[i].id}}
                }
                break
              case 45:
                obj.status = {
                  name: '已销单',
                  router: {path: '/daijia/checkOrder', query: {order_id: daijiaData[i].id}}
                }
                break
            }
            unfilledOrder.push(obj)
          }
        }
      }
      return unfilledOrder
    },
    addressRecordFn: function () {
      if (this.addressRecord.daijia.length > 0) {
        return this.addressRecord.daijia
      }
    }
  },
  data() {
    return {
      charge_id: 0, charge_type: 1,
      person_charge_id: 0, person_charge_type: 1,
      enterprise_charge_id: 0, enterprise_charge_type: 1, enterprise_budget_fee: 0,
      total_fee: 0, min_fee: 0, money: 0, companyId: null,
      ygcx: false, hasCoupon: false, is_fixed_price: 2, budget_distance: 0, budget_time: 0,
      adds: {
        startAdd: {beginAddress: '', beginAddressDetail: '', beginLat: '', beginLng: ''},
        endAdd: {endAddress: '', endAddressDetail: '', endLat: '', endLng: ''},
      },
      others: {showState: false, state: true, othersPhone: '', recordPhone: ''},
      startTime: {val: '', name: '现在出发'},
      loadState: false,
      couponMoney: {type: '', id: '', num: ''},
      hintBox: {stateShow: false, state: 'yes', content: ''},
      datePickerState: false,
      couponData: [], // 优惠券 列表
      typeAll: {action: 0, data: []},  // 子业务
      typeAcId: null, // 选中的子业务id
      budgetFee: 0, // 预算费用
      feeObj: null,
      budgetFeeRemark: '', // 预算备注
      visible: false,
      slots: [1],
      driverNumber: 1,
      app_key: '',
      is_deduction: '', //  是否开启企业优惠抵扣:1开启；2关闭
      enterprise_id: '', // 企业客户ID
      enterprise_member_deduction: '', // 企业客户抵扣金额
      enterprise_name: '', // 企业客户企业名称
      enterpriseDisabled: false, // 因公出行按钮是否禁用
      distance: 0, // 预估距离
      time: 0, // 预估时间
      route: '', // 路线json
      company_id: ''
    }
  },
  watch: {
    positioning: { // 监听定位信息--赋值起点
      handler(val) {
        if (!this.adds.startAdd.beginLat || !this.adds.startAdd.beginLng) { // 防止初始化地址的时候没拿到
          if (val && val.lng && val.lat) {
            this.adds.startAdd = {
              citycode: val.citycode,
              adcode: val.adcode,
              beginAddress: val.name,
              beginAddressDetail: val.detailedAddress,
              beginLat: val.lat,
              beginLng: val.lng,
              depart_address_detail:val.detailedAddress,
            }
            console.log('监听定位信息', this.adds.startAdd)
          }
        }
      },
      deep: true
    },
    loginData(val) {
      let that = this
      if (that.loginData && that.loginData.passenger && that.others.othersPhone === '' && that.others.recordPhone === '') {
        that.unfilledOrderShowState = true
      }
      if (that.loginData && that.loginData.passenger) {
        // this.getPassengerDaijiaFn()
      }
    },
    unfilledOrder(val) { // 如果有未结算的代驾订单，路由跳转到结算页面
      let that = this
      if (val && val.length > 0) {
        val.forEach(function (row) {
          if (Number(row.status) === 30) { // 代驾订单待结算
            if (row.business === 'daijia') {
              that.$Util.toast({text: '您有未支付的代驾订单！'})
              that.$router.push({path: '/daijia/settlement', query: {order_id: row.id, app_key: that.app_key}})
              // that.hintBox = {
              //   stateShow: true,
              //   state: 'no',
              //   content: '您有未支付的代驾订单'
              // }
              // console.log('daijia', this.$route)
              // setTimeout(function () {
              //   that.hintBox.stateShow = false
              //   that.$router.push({path: '/daijia/settlement', query: {order_id: row.id, app_key: that.app_key}})
              // }, 1500)
            }
          }
        })
      }
    }
  },
  methods: {
    async getCompanyFn(citycode, adcode) { // 获取公司信息
      let url = '/v1/company'
      let params = {ad_code: adcode, city_code: citycode}
      let data = await this.$axios.get(url, params)
      if (data && data.code === 1) {
        this.getBusinessFn(data.companyinfo.id)
        this.companyId = data.companyinfo.id
        // this.getBudgetPriceFn()
        this.$Cookie.set('companyinfo', JSON.stringify(data.companyinfo))
        this.$store.dispatch('getNearDrivers', { // 改变起点后，重新获取附近司机信息
          company_id: data.companyinfo.id,
          lng: this.adds.startAdd.beginLng, lat: this.adds.startAdd.beginLat,
          distance: 20, business: 'daijia'
        })
      }
    },
    async getBusinessFn(companyId) { // 获取公司开通的业务
      let url = '/v1/getBusiness'
      let params = {company_id: companyId, business: 'daijia'}
      let data = await this.$axios.get(url, params)
      if (data && data.code === 1) {
        this.typeAll.data = data.categories || []
        if (this.typeAll.action == 0) {
          // console.log("dfeffffff", that.typeAll)
          console.log("vettttttttttttttt", this.typeAll)
          this.$Cookie.set('typeAcId', this.typeAll.data[0].id)
          this.typeAcId = data.categories[0].id
        } else {
          if (this.$Cookie.get('typeAcId')) {
            this.typeAcId = this.$Cookie.get('typeAcId')
          } else {
            this.typeAcId = data.categories[0].id
          }
        }
        // this.typeAcId = data.categories[0].id
        // this.$Cookie.set('typeAcId', data.categories[0].id)

        if (!this.$Cookie.get('typeAcId')) {
          if (this.typeAll.data[0].is_fixed_price) {
            this.is_fixed_price = 1
          } else {
            this.is_fixed_price = 2
          }
        }
        this.getBudgetPriceFn()
      }
    },

    getBudgetPriceFn(enterprise_id) { // 获取预算费用
      let that = this
      if (this.loginData.passenger) {
        that.$store.dispatch('getBudgetPrice', {
          'order_type': 1, // 订单类型默认为普通订单
          'order_time': that.startTime.val,
          'ad_code': that.adds.startAdd.adcode,
          'company_id': that.companyId,
          'passenger_id': window.configure.passengerInfo ? window.configure.passengerInfo.id : null,
          'channel': 'wechat',
          'book_address_lat': that.adds.startAdd.beginLat,
          'book_address_lng': that.adds.startAdd.beginLng,
          'map': that.route || '',  //这是预估费用代码
          'distance': that.distance,
          'time': that.time,
          'enterprise_id': enterprise_id || '',
          'category_id': that.typeAcId,
          'search_platform': 'wechat',
          'sub_search_platform': enterprise_id ? 'enterprise' : 'onekey',
          fn(data) {
            if (data && data.code === 1 && data.applet_budget_fee) {
              if (enterprise_id) {
                if (data.applet_budget_fee.normal) {
                  that.money = data.applet_budget_fee.normal.budget_fee ? data.applet_budget_fee.normal.budget_fee / 100 : 0
                  that.enterprise_budget_fee = data.applet_budget_fee.normal.total_fee ? data.applet_budget_fee.normal.total_fee / 100 : 0
                }
                if (data.applet_budget_fee.fence) {
                  that.money = data.applet_budget_fee.fence.budget_fee ? data.applet_budget_fee.fence.budget_fee / 100 : 0
                  that.enterprise_budget_fee = data.applet_budget_fee.fence.total_fee ? data.applet_budget_fee.fence.total_fee / 100 : 0
                }
                that.enterprise_charge_id = data.applet_budget_fee.charge_id
                that.enterprise_charge_type = data.applet_budget_fee.type
              } else {
                if (data.applet_budget_fee.normal) {
                  that.budgetFee = data.applet_budget_fee.normal.budget_fee / 100
                  that.total_fee = data.applet_budget_fee.normal.total_fee / 100
                  that.min_fee = data.applet_budget_fee.normal.min_fee ? data.applet_budget_fee.normal.min_fee / 100 : 0
                  that.feeObj = data.applet_budget_fee.normal
                }
                if (data.applet_budget_fee.fence) {
                  that.budgetFee = data.applet_budget_fee.fence.budget_fee / 100
                  that.total_fee = data.applet_budget_fee.fence.total_fee / 100
                  that.min_fee = data.applet_budget_fee.fence.min_fee ? data.applet_budget_fee.fence.min_fee / 100 : 0
                  that.feeObj = data.applet_budget_fee.fence
                }
                that.person_charge_id = data.applet_budget_fee.charge_id
                that.person_charge_type = data.applet_budget_fee.type
                that.budget_time = Date.parse(new Date()) / 1000
              }
            }
          }
        })
      }
    },

    /**
     * @method 获取计价规则（费用说明）
     * @returns {Promise<void>}
     */
    async getArticlebyaliasFn() {
      let companyInfo = null
      if (Cookie.get('companyinfo')) {
        companyInfo = JSONBig.parse(Cookie.get('companyinfo'))
      }
      let params = this.$utils.objKeySort('/passenger/api/v1/articlebyalias', {
        companyId: companyInfo.id || 0,
        alias: 'CutomerPricingRules'
      })
      let data = (await this.$http.get('/v1/articlebyalias', {params})).body
      if (data && data.code === 1) {
        this.budgetFeeRemark = data.article.contents
      }
    },
    /**
     * @method 获取优惠券
     * @returns {Promise<void>}
     */
    getCouponTypeFn() { // 获取 优惠券
      let that = this
      this.$store.dispatch('v5getCoupons', {
        limit: 80,
        page: 1,
        service_type: 1,
        channel: true,
        fn(data) {
          console.log("poooooooooo", data);
          if (data.code == 300000) {
            that.hintBox = {
              stateShow: true,
              state: 'no',
              content: data.msg
            }
          }
        }
      })
    },
    async systemConfigFn(auth) {
      let appkey = this.$route.query.app_key || window.configure.appKey
      // terminal: 'wechat_boss'
      let params = this.$utils.objKeySort('/passenger/api/v1/systemConfig', {'app_key': appkey,})
      let data = (await this.$http.get('/v1/systemConfig', {params})).body
      if (data && data.code === 1) {
        // this.loadState = false
        // let systemConfig = data.package_permission
        // let permissionIds = systemConfig.split(',')
        return true
        // return auth ? permissionIds.findIndex(item => Number(item) === Number(auth)) > -1 : false
      } else {
        this.loadState = true
        this.hintBox = {
          stateShow: true,
          state: 'no',
          content: data.msg
        }
      }
    },
    startCityFn: function (obj, val) { // 起点位置 算预估费
      let that = this
      this.adds.startAdd.citycode = obj.citycode
      this.adds.startAdd.adcode = obj.adcode
      this.adds.startAdd.beginAddress = obj.name
      this.adds.startAdd.beginAddressDetail = obj.detailedAddress
      this.adds.startAdd.beginLng = obj.lng
      this.adds.startAdd.beginLat = obj.lat
      this.adds.startAdd.depart_address_detail = obj.detailedAddress
      this.getCompanyFn(obj.citycode, obj.adcode)
      console.log("llllllllll", this.loginData)
      if (this.loginData.passenger) {
        this.affirmFn()
      }
      setTimeout(() => {
        if (that.enterprise_id && that.adds.endAdd.endLng && (that.is_fixed_price === 1)) {
          that.getBudgetPriceFn()
        }
      }, 1000);
    },

    endCityFn: function (obj) { // 终点位置 算预估费
      let that = this
      this.adds.endAdd.endAddress = obj.name
      this.adds.endAdd.endAddressDetail = obj.detailedAddress
      this.adds.endAdd.destination_address_detail = obj.detailedAddress
      this.adds.endAdd.endLng = obj.lng
      this.adds.endAdd.endLat = obj.lat
      this.affirmFn()
      setTimeout(() => {
        if (that.enterprise_id && that.adds.endAdd.endLng && (that.is_fixed_price === 1)) {
          that.getBudgetPriceFn(that.enterprise_id)
        }
      }, 1000);
    },

    typeTabFn: function (obj) { // 根据业务类型菜单 算预估费
      this.typeAll.action = obj.index
      this.typeAcId = obj.data.id
      this.$Cookie.set('typeAcId', obj.data.id)
      let that = this
      this.is_fixed_price = obj.data.is_fixed_price ? 1 : 2
      // console.log("ttttttttypeTabFn", this.typeAll, obj.data, this.is_fixed_price)
      that.$store.dispatch('checkLogin', (state) => {
        if (state && that.loginData && this.loginData.passenger) {
          if (that.enterprise_id && that.adds.endAdd.endLng && (that.is_fixed_price === 1)) {
            that.getBudgetPriceFn(that.enterprise_id)
          }
          if (that.adds.endAdd.endLng && that.adds.endAdd.endLng !== '') {
            that.affirmFn()
          } else {
            that.getBudgetPriceFn()
          }
        }
      })
    },

    affirmFn: function () { // 预算费用
      let that = this
      if (that.adds.endAdd.endLng && that.adds.endAdd.endLat) {  // 有终点位置时算预估费
        let routesDataSet = {}
        let route = null
        that.$store.dispatch('routePlanning', {
          originLng: that.adds.startAdd.beginLng,
          originLat: that.adds.startAdd.beginLat,
          destinationLng: that.adds.endAdd.endLng || '',
          destinationLat: that.adds.endAdd.endLat || '',
          fn(data) {
            if (data.status === '1') {
              let driving = data.route.paths
              if (driving.length > 1) {
                let distanceArr = [];
                const sortClass1 = sortData => {
                  const groupBy1 = (array, f) => {
                    let groups1 = {};
                    array.forEach(o => {
                      let group1 = JSON.stringify(f(o));
                      groups1[group1] = groups1[group1] || [];
                      groups1[group1].push(o);
                    });
                    return Object.keys(groups1).map(group1 => {
                      return groups1[group1];
                    });
                  };
                  const sorted1 = groupBy1(sortData, item => {
                    return item.distance; // 返回需要分组的对象
                  });
                  return sorted1;
                };
                // 分组后
                distanceArr = sortClass1(driving)
                if (distanceArr[0].length > 1) {
                  let timeArr = [];
                  const sortClass2 = sortData => {
                    const groupBy2 = (array, f) => {
                      let groups2 = {};
                      array.forEach(o => {
                        let group2 = JSON.stringify(f(o));
                        groups2[group2] = groups2[group2] || [];
                        groups2[group2].push(o);
                      });
                      return Object.keys(groups2).map(group2 => {
                        return groups2[group2];
                      });
                    };
                    const sorted2 = groupBy2(sortData, item => {
                      return item.duration; // 返回需要分组的对象
                    });
                    return sorted2;
                  };
                  // 分组后
                  timeArr = sortClass2(distanceArr)
                  if (timeArr.length > 1) {
                    // 到这一步是不可能的
                    routesDataSet = timeArr[0]
                  } else {
                    routesDataSet = timeArr[0]
                  }
                } else {
                  routesDataSet = distanceArr[0]
                }
              } else {
                routesDataSet = driving[0]
              }
              let stepsRaws = Array.isArray(routesDataSet) ? routesDataSet[0].steps : routesDataSet.steps;
              let stepsRawsDiss = [], stepsRawsDissObj = {};
              if (Array.isArray(routesDataSet)) {
                for (let i = 0; i < stepsRaws.length; i++) {
                  stepsRawsDissObj = {
                    distance: stepsRaws[i].distance,
                    duration: stepsRaws[i].duration,
                    polyline: stepsRaws[i].polyline
                  }
                  stepsRawsDiss.push(stepsRawsDissObj)
                }
                route = {
                  duration: routesDataSet[0].duration,
                  distance: routesDataSet[0].distance,
                  steps: stepsRawsDiss
                }
                route.duration = Number(route.duration)
                route.distance = Number(route.distance)
                route.steps.forEach(item => {
                  item.distance = Number(item.distance)
                  item.duration = Number(item.duration)
                })
                this.distance = routesDataSet[0].distance / 1000
                this.time = Math.ceil(routesDataSet[0].duration / 60)
              } else {
                for (let i = 0; i < stepsRaws.length; i++) {
                  stepsRawsDissObj = {
                    distance: stepsRaws.distance,
                    duration: stepsRaws.duration,
                    polyline: stepsRaws.polyline
                  }
                  stepsRawsDiss.push(stepsRawsDissObj)
                }
                route = {
                  duration: routesDataSet.duration,
                  distance: routesDataSet.distance,
                  steps: stepsRawsDiss
                }
                route.duration = Number(route.duration)
                route.distance = Number(route.distance)
                route.steps.forEach(item => {
                  item.distance = Number(item.distance)
                  item.duration = Number(item.duration)
                })
                this.distance = routesDataSet.distance / 1000
                this.time = Math.ceil(routesDataSet.duration / 60)
              }
              if (!route) {
                this.route = ''
              } else {
                that.budget_distance = route.distance
                that.distance = route.distance
                that.time = route.duration
                that.route = JSON.stringify(route)
              }
              that.getBudgetPriceFn()
            }
          }
        })
      } else { // 无终点位置时算预估费
        that.distance = '';
        that.time = '';
        that.getBudgetPriceFn()
      }
    },
    othersPhoneFn: function (obj) { // 他人电话
      let that = this
      switch (obj) {
        case 'affirm':
          that.others.showState = false
          if (that.others.othersPhone === '') {
            that.others.state = true
            that.others.othersPhone = ''
            that.others.recordPhone = that.$store.state.mc.phoneNo
            return false
          }
          if (that.others.othersPhone !== that.$store.state.mc.phoneNo) {
            that.others.state = false
            that.others.recordPhone = that.others.othersPhone
          } else {
            that.others.state = true
            that.others.recordPhone = that.others.othersPhone
            that.others.othersPhone = ''
          }
          break
        case 'cancel':
          that.others.showState = false
          if (Toucth.checkPhone(that.others.othersPhone) && that.others.othersPhone === that.$store.state.mc.phoneNo) {
            that.others.state = true
            that.others.othersPhone = ''
          }
          if (Toucth.checkPhone(that.others.othersPhone) && that.others.recordPhone !== that.others.othersPhone) {
            that.others.state = false
            that.others.othersPhone = that.others.recordPhone
          }
          if (!Toucth.checkPhone(that.others.othersPhone) && that.others.recordPhone !== that.others.othersPhone && that.others.recordPhone !== that.$store.state.mc.phoneNo) {
            that.others.state = false
            that.others.othersPhone = that.others.recordPhone
          }
          if (!Toucth.checkPhone(that.others.othersPhone) && that.others.recordPhone !== that.others.othersPhone && that.others.recordPhone === that.$store.state.mc.phoneNo) {
            that.others.state = true
            that.others.othersPhone = ''
          }
          break
        case 'show':
          that.others.showState = true
          setTimeout(() => {
            if (Toucth.checkPhone(that.others.othersPhone) || that.others.othersPhone === '') {
              that.$refs.othersPhone.affStateFn(true)
            } else {
              that.$refs.othersPhone.affStateFn(false)
            }
          }, 0)
          break
      }
    },
    othersStateFn: function () { // 他人是否显示
      if (this.others.othersPhone !== '' && this.others.state) {
        this.$refs.othersPhone.stateFn()
      } else {
        this.others.state = true
      }
    },
    othersPhoneCheck: function () { // 他人电话
      if (Toucth.checkPhone(this.others.othersPhone) || this.others.othersPhone === '') {
        this.$refs.othersPhone.affStateFn(true)
      } else {
        this.$refs.othersPhone.affStateFn(false)
      }
    },
    callCarFn: function (type) { // 呼叫
      let that = this
      that.loadState = true
      that.$store.dispatch('checkLogin', (state) => {
        if (state) {
          // 初始化起点和预算费用
          if (!that.adds.startAdd.beginLat || !that.adds.startAdd.beginLng) { // 防止初始化地址的时候没拿到
            if (this.positioning && this.positioning.lng && this.positioning.lat) {
              this.adds.startAdd = {
                beginAddress: this.positioning.name,
                beginAddressDetail: this.positioning.detailedAddress,
                beginLat: this.positioning.lat,
                beginLng: this.positioning.lng
              }
            }
          }
          if (!that.adds.startAdd.beginLat || !that.adds.startAdd.beginLng || !that.adds.startAdd.beginAddress) {
            // that.loadState = false
            that.hintBox = {
              stateShow: true,
              state: 'no',
              content: '请选择起点'
            }
            setTimeout(() => {
              that.loadState = false
              that.hintBox.stateShow = false
            }, 1500)
            return false
          }
          let bookTime = 0
          if (that.startTime.name === '现在出发') {
            let timetamp = Date.parse(new Date()) / 1000
            bookTime = that.startTime.val ? that.startTime.val : timetamp // 时间戳为NaN时获取当前时间
          } else {
            bookTime = (that.startTime.val) / 1000
          }
          if (that.loginData && that.loginData.passenger && that.adds.startAdd.beginLat && that.adds.startAdd.beginLng) {
            let obj = {
              'order_person': that.loginData.passenger.name,
              'order_person_id': that.loginData.passenger.id,
              'number': that.driverNumber,
              'cid': that.typeAcId,
              'passenger_phone': that.loginData.passenger.phone,
              'channelName': 'wechat',
              'book_address': that.adds.startAdd.beginAddress,
              'startAddressDetail': that.adds.startAdd.beginAddressDetail,
              'book_address_lat': that.adds.startAdd.beginLat,
              'book_address_lng': that.adds.startAdd.beginLng,
              'user_phone': that.others.recordPhone,
              'destination': that.adds.endAdd.endAddress,
              'endAddressDetail': that.adds.endAdd.endAddressDetail,
              'destination_lat': that.adds.endAdd.endLat,
              'destination_lng': that.adds.endAdd.endLng,
              'book_time': bookTime,
              'budget_fee': that.total_fee || 0,
              'coupon_id': that.couponMoney.id,
              'ad_code': that.adds.startAdd.adcode,
              'order_type': 1, // 订单类型默认为普通订单
              // depart_address_detail: that.adds.startAdd.depart_address_detail || that.adds.startAdd.beginAddressDetail,
              // destination_address_detail: that.adds.endAdd.destination_address_detail,
              fn(data) {
                if (data && data.code === 1) {
                  that.$Cookie.set('typeAcId', '')
                  that.hintBox = {
                    stateShow: true,
                    state: 'yes',
                    content: '下单成功！'
                  }
                  setTimeout(() => {
                    that.loadState = false
                    that.hintBox.stateShow = false
                    that.$router.push({
                      path: '/daijia/await',
                      query: {order_id: data.ids[0]}
                    })
                  }, 1300)
                } else if (data.code === 31012) {
                  that.hintBox = {
                    stateShow: true,
                    state: 'no',
                    content: '选择多位司机时，不能使用优惠券！'
                  }
                  setTimeout(() => {
                    that.loadState = false
                    that.hintBox.stateShow = false
                  }, 1300)
                } else if (data.code === 30014) {
                  that.hintBox = {
                    stateShow: true,
                    state: 'no',
                    content: '你已被加入黑名单！'
                  }
                  setTimeout(() => {
                    that.loadState = false
                    that.hintBox.stateShow = false
                  }, 1300)
                } else if (data.code === 20091) {
                  that.hintBox = {
                    stateShow: true,
                    state: 'no',
                    content: '你的并行订单量已经达到上限！'
                  }
                  setTimeout(() => {
                    that.loadState = false
                    that.hintBox.stateShow = false
                  }, 1300)
                } else if (data.code === 120701) {
                  that.hintBox = {
                    stateShow: true,
                    state: 'no',
                    content: '业务受限，请刷新后重试！'
                  }
                  setTimeout(() => {
                    that.loadState = false
                    that.hintBox.stateShow = false
                  }, 1300)
                } else if (data.code === 120704) {
                  that.hintBox = {
                    stateShow: true, state: 'no',
                    content: data.msg
                  }
                  that.getBudgetPriceFn()
                  setTimeout(() => {
                    that.enterprise_id && that.getBudgetPriceFn()
                  }, 500);
                  setTimeout(() => {
                    that.loadState = false
                    that.hintBox.stateShow = false
                  }, 1300)
                } else if (data.code === 300000) {
                  that.hintBox = {
                    stateShow: true,
                    state: 'no',
                    content: data.msg
                  }
                  setTimeout(() => {
                    that.loadState = false
                    that.hintBox.stateShow = false
                  }, 1300)
                } else {
                  that.hintBox = {
                    stateShow: true,
                    state: 'no',
                    content: data.msg
                  }
                  setTimeout(() => {
                    that.loadState = false
                    that.hintBox.stateShow = false
                  }, 1300)
                }
              }
            }
            // 若存在企业客户ID(该乘客是企业客户成员)且点击了因公出行的按钮
            if (that.enterprise_id && type === 'official') {
              obj.enterprise_id = this.enterprise_id
              obj.enterprise_member_deduction = this.enterprise_member_deduction
              obj.order_type = 2
              obj.budget_fee = that.enterprise_budget_fee || 0
              that.charge_id = that.enterprise_charge_id
              that.charge_type = that.enterprise_charge_type
            } else {
              that.charge_id = that.person_charge_id
              that.charge_type = that.person_charge_type
            }
            if (that.is_fixed_price == 1) {
              if (!obj.destination_lat) {
                that.hintBox = {
                  stateShow: true,
                  state: 'no',
                  content: '一口价订单需选择目的地'
                }
                setTimeout(() => {
                  that.loadState = false
                  that.hintBox.stateShow = false
                }, 1300)
              } else {
                obj.is_fixed_price = that.is_fixed_price
                obj.fixed_price = JSON.stringify({
                  budget_time: that.budget_time,
                  budget_distance: that.budget_distance / 1000,
                  price: type === 'official' ? that.enterprise_budget_fee : that.total_fee,
                  min_fee: that.min_fee, charge_id: that.charge_id, charge_type: that.charge_type,
                  deduct: 0, deduct_type: 3
                })
                that.$store.dispatch('postCreateOrder', obj)
              }
            } else {
              that.$store.dispatch('postCreateOrder', obj)
            }
          }
        } else {
          // that.$store.dispatch('loginAction', {state: false})
          // that.loadState = false
          this.$router.push('/login')
        }
      })
    },
    DatePickerFn: function (time) { // 时间选择
      if (time) {
        console.log('时间选择', time)
        this.startTime.val = time.val
        this.startTime.name = time.name
      }
      this.datePickerState = false
    },
    selectTimeFn: function () { // 时间选择
      // this.datePickerState = true
    },
    async couponSlelectFn(obj) {
      this.hasCoupon = await this.systemConfigFn(10)
      if (this.hasCoupon) {
        console.log("sssssssss", this.hasCoupon);
        if (obj.type === 'nonuse') {
          if (this.enterprise_id) {
            this.enterpriseDisabled = false
          }
          this.couponMoney = {
            type: '',
            id: '',
            num: ''
          }
          return true
        }
        if (obj.type === 'action' && obj.obj && obj !== '') {
          // 企业客户选择优惠券
          if (this.enterprise_id) {
            this.$Util.toast({text: '选择优惠券后，您将不可使用因公出行'})
            this.enterpriseDisabled = true
          }
          if (obj.obj.discount && obj.obj.discount !== '') {
            this.couponMoney = {
              type: 'dazhe',
              val: obj.obj.discount,
              id: obj.obj.id
            }
          } else if (obj.obj.deductible && obj.obj.deductible !== '') {
            this.couponMoney = {
              type: 'dikou',
              val: obj.obj.deductible,
              id: obj.obj.id
            }
          }
          return true
        }
      }
    },
    unfilledOrdercCloseFn: function () {
      this.$store.dispatch('unfilledOrderState', {type: 'daijia', state: false})
    },
    detailsBoxFn: function () { // 详情事件
      if (this.$refs.detailsBox) {
        this.$refs.detailsBox.switchFn()
      }
    },
    chooseDriverFn() { // 选择司机个数
      let that = this
      that.$store.dispatch('checkLogin', (state) => {
        console.log('选择司机个数', state, 'that.loginData', that.loginData)
        if (state && that.loginData && that.loginData.passenger) {
          that.visible = true
        } else {
          that.$store.dispatch('loginAction', {state: false})
        }
      })
    },
    sureSelectCar(val) { // 司机选择确认
      this.visible = false
      this.driverNumber = val[0]
    },
    cancleSelectCar(val) { // 司机选择取消
      this.visible = false
    },
    getPassengerDaijiaFn() { // 获取个人信息
      let that = this
      let appkey = this.$route.query.app_key || window.configure.appKey
      let passengerId = window.configure.passengerInfo ? window.configure.passengerInfo.id : null
      this.$store.dispatch('getPassenger', {
        id: passengerId,
        app_key: appkey,
        fn(data) {
          console.log('获取个人信息', data)
          if (data.data.code === 1) {
            let singleOrder = Number(data.data.grade.single_order)
            if (singleOrder > 1) {
              that.slots = []
              for (let i = 1; i <= singleOrder; i++) {
                that.slots.push(i)
              }
            }
          }
          let passengerkey = window.configure.passengerKey
          let passenger = that.$Cookie.get(passengerkey) ? JSONBig.parse(that.$Tool.aesDecryptCode(that.$Cookie.get(passengerkey))) : null
          if (passenger && passenger.passenger) {
            that.enterprise_id = passenger.passenger.enterprise_id
            that.enterprise_member_deduction = passenger.passenger.enterprise_member_deduction
            that.enterprise_name = passenger.passenger.enterprise_name
            that.is_deduction = passenger.passenger.is_deduction
            if (passenger.passenger.is_deduction === 2) {
              that.enterpriseDisabled = true
            }
          }
        }
      })
    }
  },
  async created() {
    this.ygcx = await this.systemConfigFn(2)
    this.app_key = this.$route.query.app_key
    this.$store.dispatch('checkLogin', (state) => {
      if (state) {
        this.getPassengerDaijiaFn()
        if (this.loginData && this.loginData.passenger) {
          this.$store.dispatch('unfilledOrder', {page: 1, limit: 100}) // 为完成订单
          // console.log('代驾首页-mounted-未完成订单:', this.unfilledOrder)
          this.unfilledOrderShowState = true
        }
      }
    })
    // let passengerkey = window.configure.passengerKey
    // let passenger = this.$Cookie.get(passengerkey) ? JSONBig.parse(this.$Tool.aesDecryptCode(this.$Cookie.get(passengerkey))) : null
    // console.log('代驾首页created--客户key--获取用户信息', passenger)
    // if (passenger && passenger.passenger) {
    //   this.enterprise_id = passenger.passenger.enterprise_id
    //   this.enterprise_member_deduction = passenger.passenger.enterprise_member_deduction
    //   this.enterprise_name = passenger.passenger.enterprise_name
    //   if (passenger.passenger.is_deduction === 2) {
    //     this.enterpriseDisabled = true
    //   }
    // }
  },
  mounted: function () {
    let that = this
    // setTimeout(() => {
    //   if(that.typeAll) {
    //     if(that.typeAll.action == 0) {
    //       console.log("dfeffffff", that.typeAll)
    //       that.$Cookie.set('typeAcId', that.typeAll.data[0].id)
    //     }
    //   }
    // }, 1000);

    if (this.$route.query.tel) {
      this.$store.dispatch('checkLogin', (state) => {
        if (state) {
        } else {
          that.$store.dispatch('loginAction', {state: false})
        }
      })
    }
    that.$store.dispatch('getBusiness', {
      business: 'daijia',
      company_id: 1,
      fn(data) {
        if (data && data.code === 1) {
          let business = data.categories // 子业务
          if (business && business.length > 0) {
            // if(that.$Cookie.get('typeAcId')) {
            //   that.typeAcId = that.$Cookie.get('typeAcId')
            // } else {
            //   that.typeAcId = business[0].id
            //   that.$Cookie.set('typeAcId', business[0].id)
            // }
            that.typeAcId = business[0].id
            that.$Cookie.set('typeAcId', business[0].id)
            that.typeAll.data = [...business]
            if (business[0].is_fixed_price) {
              that.is_fixed_price = 1
            } else {
              that.is_fixed_price = 2
            }
          }
          that.getArticlebyaliasFn()
          that.getCouponTypeFn()
          // if(this.hasCoupon = this.systemConfigFn(10)) {
          //   that.getCouponTypeFn()
          // }
        }
      }
    })
    // 初始化起点和预算费用
    if (this.positioning && this.positioning.lng && this.positioning.lat) {
      this.adds.startAdd = {
        beginAddress: this.positioning.name,
        beginAddressDetail: this.positioning.detailedAddress,
        beginLat: this.positioning.lat,
        beginLng: this.positioning.lng
      }
    }
    let date = new Date()
    that.startTime.name = '现在出发'
    that.startTime.val = Date.parse(date) / 1000
    let company = this.$Cookie.get('companyinfo')
    setTimeout(() => {
      if (window.configure.location) {
        that.$store.dispatch('getNearDrivers', {
          company_id: company.id,
          lng: window.configure.location.lng || null,
          lat: window.configure.location.lat || null,
          distance: 10,
          business: 'daijia'
        })
      }
    }, 1000)
  }
}
</script>
<style rel="stylesheet/less" lang="less">
.DaiJia {
  .content {
    box-sizing: border-box;
    width: 100%;
    padding: 0 1rem;

    .banner {
      width: 100%;
      height: 5rem;
      border-radius: 0.333rem;
      overflow: hidden;
    }

    .typeNav {
      background-color: #eeeeee;
      width: 100%;
      height: 3rem;
      line-height: 3.75rem;
    }

    .setSite {
      background-color: #fff;
      margin-top: 1rem;
      border-radius: 0.333rem;

      .title {
        text-align: center;
        font-size: 1rem;
        line-height: 3rem;
        border-bottom: 1px solid #eee;
        color: #999;
      }

      .row {
        width: 100%;
        box-sizing: border-box;
        border-bottom: 1px solid #f2f2f2;
        line-height: 3.5rem;
        padding: 0 1rem;
        transition: 0.3s all;

        i {
          float: left;
          margin-right: 0.5rem;
        }

        .icon-yuan {
          font-size: 1rem;
        }

        .val {
          min-width: 90%;
          float: left;
          width: auto;
        }
      }

      .row1 {
        margin: 0 1rem;
        width: calc(~'100% - 2rem');

        i {
          color: #3cafb9;
        }
      }

      .row2 {
        padding-left: 2rem;

        i {
          color: #f06553;
        }
      }

      .row3 {
        text-align: center;

        .top {
          width: 100%;
          /*padding: 0 1rem;*/
          height: 3.666rem;
          overflow: hidden;
          line-height: 3.666rem;

          .list {
            box-sizing: border-box;
            width: 49%;

            i {
              font-size: 0.833rem;
              color: #bbbbbb;
            }

            p {
              float: left;
              font-size: 1rem;
              color: #bbbbbb;
            }

            .listVal {
              float: left;
              /*width: 80%;*/
            }
          }

          .listAc {
            i, p {
              color: #333;
            }
          }

          .bottom {
            display: inline-block;
            width: 75%;

            input {
              box-sizing: border-box;
              display: inline-block;
              line-height: 2rem;
              width: 100%;
              padding: 0 0.5rem;
              background-color: #f3f4f5;
              border: none;
              border-radius: 0.333rem;
            }
          }
        }
      }

      .totalNum {
        position: relative;

        .line {
          width: 1px;
          height: 50%;
          background-color: #eee;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }

        .row {
          box-sizing: border-box;
          float: left;
          width: 50%;
          text-align: center;
          border-bottom: none;
          font-size: 0.8333rem;

          .couponSelectList {
            .val {
              float: right;
              width: auto;
            }
          }
        }

        .red {
          font-size: 1.5rem;
          color: #f06553;
          margin: 0 0.3rem;
        }

        i {
          float: none;
          color: #999;
          font-size: 0.8333rem;
        }
      }
    }

    .callOutBut {
      box-sizing: border-box;
      margin-top: 1rem;
      width: 100%;

      button {
        width: 100%;
        text-align: center;
        height: 3.75rem;
        line-height: 3.75rem;
        border-radius: 0.333rem;
        background-color: #f06553;
        color: #fff;
        font-size: 1.25rem;
        border: none;
        margin-bottom: 8px;
      }

      .disable {
        background-color: #ccc;
      }
    }

    .xieyi {
      margin-top: 0.5rem;

      p {
        font-size: 1rem;
        color: #999;

        a {
          color: #f06553;
        }
      }
    }
  }

  .costBox {
    ul {
      li {
        height: 2rem;
        line-height: 2rem;
        color: #999;

        .name {
          float: left;
        }

        .time, .val {
          float: right;
        }

        .time {
          margin-right: 0.8rem;
          color: #666;
        }

        .sum {
          color: #f06553;
        }

        .unit {
          margin-left: 0.3rem;
        }
      }
    }

    .introduce {
      border-top: 1px solid #eee;
      margin-top: 0.5rem;
      padding-top: 1.2rem;
      line-height: 1.8rem;
      color: #666;
    }
  }
}
</style>



// WEBPACK FOOTER //
// daijia.vue?5c04fec8